import type { SAMAChat, XMPPChat } from './ConnectyCube';

export type { SAMAChat, XMPPChat };
export type * from './types';

import * as constants from './types/constants';
import ConnectyCube from './ConnectyCube';
export default Object.assign(new ConnectyCube(), { ConnectyCube, ...constants });
